import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import useAuthStore from '@/store/authStore';

export function Layout() {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-background grid-bg">
      <Sidebar />
      <main className="ml-64 min-h-screen transition-all duration-300" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
